module.exports = __webpack_public_path__ + "static/img/des.dcd3793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/des.png
// module id = hByK
// module chunks = 1